// extracted by mini-css-extract-plugin
export default {"psbBannerWrap":"Main_psbBannerWrap__AE1Zj","psbBannerInner":"Main_psbBannerInner__m3v+B","psbBanner":"Main_psbBanner__yxSHF","btnInfo":"Main_btnInfo__2ku-3"};